import {
  IPrioritySection,
  IViewConfiguration
} from '@ispm/therapies/interfaces/view-configuration.interface';
import { IWorkflowJobItem } from '@ispm/workflow/interfaces/job-item.interface';
import { get } from 'lodash';
import { IConfigurationAdapter } from '@ispm/therapies/interfaces/configuration-adapter.interface';
import { Injectable } from '@angular/core';
import { IDefinition } from '../../configuration/interfaces/definition.interface';
import { DEFAULT_VIEW_CONFIGURATION } from '@ispm/therapies/constants/default-view-configuration.constant';
import { ConditionalOperator } from '@ispm/shared/constants/conditional-operator.enum';
import * as _ from 'lodash';

@Injectable()
export class PrioritizationConfigurationAdapter implements IConfigurationAdapter {
  static PrioritySectionConfiguration: IPrioritySection = {
    type: 'priority',
    title: 'Plan summary',
    textEditable: true,
    list: {
      fields: [
        {
          path: 'displayName',
          label: 'Title',
        },
        {
          path: 'gene',
          label: 'Gene',
          fallbackPath: 'target'
        },
        {
          path: 'aberration',
          label: 'Aberration'
        }
      ],
      priorityAvailable: true
    },
    actions: [
      {
        command: 'submit',
        label: 'Submit for review',
        buttonType: 'primary',
        conditions: [
          {
            path: 'edit',
            value: true,
            operator: ConditionalOperator.EQ
          }
        ],
        modal: {
          title: 'Are you sure you want to submit review?',
          mainButton: 'Submit review',
          secondaryButton: 'Cancel'
        }
      },
      {
        command: 'signoff',
        label: 'Signoff',
        requiredPermission: 'THERAPYMATCH.SIGNOFF.WRITE',
        buttonType: 'primary',
        conditions: [
          {
            path: 'signoff',
            value: true,
            operator: ConditionalOperator.EQ
          }
        ],
        modal: {
          title: 'Are you sure you want to move this case to the sign out stage?',
          mainButton: 'Yes',
          secondaryButton: 'No'
        }
      },
      {
        command: 'reset',
        label: 'Reset',
        buttonType: 'secondary',
        conditions: [
          {
            path: 'edit',
            value: true,
            operator: ConditionalOperator.EQ
          }
        ]
      }
    ]
  };
  static GenomicsConfigurationTypes = ['reflex', 'priority'];

  public runAdapter(currentStep: IWorkflowJobItem, definition: IDefinition, configuration: IViewConfiguration): void {
    if (
      configuration.summary_section.type &&
      !Object['values'](PrioritizationConfigurationAdapter.GenomicsConfigurationTypes).includes(configuration.summary_section.type)
    ) {
      return;
    }

    if (!configuration.summary_section.type) {
      configuration.summary_section = this.shouldDisplayReflex(definition, currentStep)
        ? { type: 'reflex', title: ''}
        : PrioritizationConfigurationAdapter.PrioritySectionConfiguration;
    }

    configuration.subject_selection_section.payload = configuration.subject_selection_section.payload || { };
    configuration.subject_selection_section.payload.allTherapies = get(definition, 'therapyMatch.allTherapies', false);

    switch (configuration.summary_section.type) {
      case 'priority':
        this.setPriorityConfiguration(definition, configuration.summary_section as IPrioritySection);
        break;
      default:
        break;
    }
  }


  getViewConfig(definition: IDefinition, currentStep: IWorkflowJobItem, jobPurpose?: string): IViewConfiguration {
    const configuration = jobPurpose && definition[jobPurpose]?.TreatmentLayout
      || definition.TreatmentLayout || _.cloneDeep(DEFAULT_VIEW_CONFIGURATION);

    // mutates origin
    this.runAdapter(currentStep, definition, configuration);
    return configuration;
  }

  private setPriorityConfiguration(configuration, configurationToPopulate: IPrioritySection) {
    if (configuration.therapyMatch) {
      configurationToPopulate.list.allowManual = get(configuration.therapyMatch, 'allowManualTherapies', true);
      configurationToPopulate.list.allowTherapyFreeText = get(configuration.therapyMatch, 'allowTherapyFreeText');
      configurationToPopulate.list.targetMaxLength = get(configuration.therapyMatch, 'targetMaxLength', 30);
    }
  }

  private shouldDisplayReflex(configuration: IDefinition, currentStep: IWorkflowJobItem) {
    // Checks the ManualCurationAvailable property against the "TestConfiguration" table StepType
    return !!currentStep && get(configuration, currentStep.type + '.manualCurationAvailable');
  }
}
